import { render, staticRenderFns } from "./CampaignsPage.vue?vue&type=template&id=46ca4286&scoped=true"
import script from "./CampaignsPage.vue?vue&type=script&lang=js"
export * from "./CampaignsPage.vue?vue&type=script&lang=js"
import style0 from "./CampaignsPage.vue?vue&type=style&index=0&id=46ca4286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ca4286",
  null
  
)

export default component.exports